import React from "react";
import { Routes, Route } from "react-router-dom";
import LayoutPage from "./components/LayoutPage";
import StoolInference from "./components/Stool/StoolInference";

function AppRouter() {
    if (window.defaultroute === undefined) {
        window.defaultroute = "/";
    }
    return (
        <Routes>
            <Route path={window.defaultroute} element={<LayoutPage />}>
                <Route index element={<StoolInference />} />
                <Route path="/api-demosite-stool" element={<StoolInference />} />

                {/* Using path="*"" means "match anything", so this route
                acts like a catch-all for URLs that we don't have explicit
                routes for. */}
                {/* <Route path="*" element={<NoMatch />} /> */}
            </Route>
        </Routes>
    );
}

export default AppRouter;
